export const theme = {
  colors: {
    background: "#fff",
  },
  styles: {
    blockquote: {
      fontWeight: "normal",
      fontSize: "1em",
      color: "grey",
      strong: {
        color: "black",
      },
    },
    p: {
      fontSize: "1em",
    },
    CodeSurfer: {
      title: {
        backgroundColor: "#fff",
      },
      pre: {
        backgroundColor: "#fff",
      },
      code: {
        backgroundColor: "#fff",
      },
    },
  },
};
